<template>
    <iframe :src="src"></iframe>
</template>

<script>
import axios from '@/Helpers/AxiosInstance.js'
export default {
    created() {
        axios
            .get('WebShop/GetSportsBookJWTToken', {
                params: {
                    accountCardId: this.cardID,
                },
            })
            .then(resp => this.loadIFrame(resp))
    },
    data() {
        return {
            src: ''
        }
    },
    methods: {
        loadIFrame(resp) {
            let token = resp.data.token.response
            this.src = `https://sport.upgaming.com/admin/html/reports/iframe_general.html?jwttoken=${token}`
        },
    }
}
</script>

<style scoped lang="scss">
iframe {
    width: 100%;
    height: calc(100vh - #{100 * $rem});
}
</style>